import { schema } from "normalizr"

export default new schema.Entity("status", {}, { idAttribute: "statusId" })
